import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const PAYMENT_METHODS = ['Visa', 'Mastercard', 'GCash', 'Maya', 'PayPal', 'Crypto'];

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.grid}>
          <div className={styles.brand}>
            <span className={styles.brandRow}>
              🌿 Kon<b>Store</b>
            </span>
            <p className={styles.tagline}>
              Fast, safe Grow a Garden items with instant delivery. Trusted marketplace seller with
              thousands of completed orders.
            </p>
            <div className={styles.pay}>
              {PAYMENT_METHODS.map((m) => (
                <span key={m} className={styles.payChip}>
                  {m}
                </span>
              ))}
            </div>
          </div>

          <nav aria-label="Shop">
            <h3 className={styles.colTitle}>Shop</h3>
            <div className={styles.links}>
              <Link to="/catalog">All Items</Link>
              <Link to="/catalog?category=seed">Seeds</Link>
              <Link to="/catalog?category=pet">Pets</Link>
              <Link to="/catalog?category=gear">Gear</Link>
              <Link to="/catalog?category=bundle">Bundles</Link>
            </div>
          </nav>

          <nav aria-label="Company">
            <h3 className={styles.colTitle}>Company</h3>
            <div className={styles.links}>
              <Link to="/about">About</Link>
              <Link to="/contact">Contact</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/refunds">Refund Policy</Link>
            </div>
          </nav>

          <nav aria-label="Community">
            <h3 className={styles.colTitle}>Community</h3>
            <div className={styles.links}>
              <a href="https://discord.gg/your-invite" target="_blank" rel="noreferrer noopener">
                Discord
              </a>
              <a href="https://tiktok.com/@konstore" target="_blank" rel="noreferrer noopener">
                TikTok
              </a>
              <a href="https://youtube.com/@konstore" target="_blank" rel="noreferrer noopener">
                YouTube
              </a>
            </div>
          </nav>
        </div>

        <div className={styles.bottom}>
          <span>© {year} Kon Store. All rights reserved.</span>
          <span className={styles.disclaimer}>
            Not affiliated with, endorsed by, or sponsored by Roblox Corporation or the creators of
            Grow a Garden. All trademarks belong to their respective owners.
          </span>
        </div>
      </div>
    </footer>
  );
}
